export default __webpack_public_path__ + "static/media/element_50.0922c66c.jpg";